import {UserConst} from '@/models/User'

export class gPromise {
    // promise_load_carts: boolean = false
    // promise_create_cart: boolean = false

}


export class gVariable {
    static promise = new gPromise()
    static tabs = {
        // profile: {
        //     name: 'Profile',
        //     path: '/profile',
        //     click: () => {
        //     },
        //     permissions: [],
        //     badge: false,
        //     isLoad: false,
        // },
        // overview: {
        //     name: 'ภาพรวม',
        //     path: '/overview',
        //     click: () => {
        //     },
        //     permissions: [
        //         UserConst.ROLE_ADMIN,
        //         UserConst.ROLE_CEO,
        //         UserConst.ROLE_DIRECTOR,
        //         UserConst.ROLE_MANAGER,
        //         UserConst.ROLE_ACCOUNT,
        //         UserConst.ROLE_USER,
        //     ],
        //     badge: false,
        //     isLoad: false,
        // },
        // customers: {
        //     name: 'ลูกค้า',
        //     path: '/customer',
        //     click: () => {
        //     },
        //     permissions: [
        //         UserConst.ROLE_ADMIN,
        //         UserConst.ROLE_CEO,
        //         UserConst.ROLE_DIRECTOR,
        //         UserConst.ROLE_MANAGER,
        //         UserConst.ROLE_ACCOUNT,
        //         UserConst.ROLE_USER,
        //     ],
        //     badge: false,
        //     isLoad: false,
        // },
        products: {
            name: 'สินค้า',
            path: '/product',
            click: () => {
            },
            permissions: [
            ],
            badge: false,
            isLoad: false,
        },
        // promotions: {
        //   name: 'โปรฯ',
        //   path: '/promotion',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_USER,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // orders: {
        //   name: 'ออเดอร์',
        //   path: '/order',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_CEO,
        //     UserConst.ROLE_DIRECTOR,
        //     UserConst.ROLE_MANAGER,
        //     UserConst.ROLE_ACCOUNT,
        //     UserConst.ROLE_USER,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // orders_pending: {
        //   name: 'อนุมัติ',
        //   path: '/order_pending',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_CEO,
        //     UserConst.ROLE_DIRECTOR,
        //     UserConst.ROLE_MANAGER,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        issue: {
            name: 'Issue',
            path: '/issue',
            click: () => {
            },
            permissions: [
            ],
            badge: false,
            isLoad: false,
        },
        opc: {
            name: 'OPC',
            path: '/opc_block',
            click: () => {
            },
            permissions: [
            ],
            badge: false,
            isLoad: false,
        },
        // logistic_cal: {
        //   name: 'โลจีสติก',
        //   path: '/logistic_cal',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_LOGISTIC,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // logistic_setting: {
        //   name: 'โลจีสติก',
        //   path: '/logistic_setting',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_LOGISTIC,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // truck: {
        //   name: 'รถ',
        //   path: '/trucks',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_LOGISTIC,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // province: {
        //   name: 'จังหวัด',
        //   path: '/provinces',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_LOGISTIC,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // report: {
        //   name: 'รายงาน',
        //   path: '/report',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_CEO,
        //     UserConst.ROLE_DIRECTOR,
        //     UserConst.ROLE_MANAGER,
        //     UserConst.ROLE_ACCOUNT,
        //     UserConst.ROLE_USER,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
        // carts: {
        //   name: 'สั่งสินค้า',
        //   path: '/cart',
        //   click: () => {
        //   },
        //   permissions: [
        //     UserConst.ROLE_ADMIN,
        //     UserConst.ROLE_USER,
        //   ],
        //   badge: false,
        //   isLoad: false,
        // },
    }

    static tabs_array = [
        // {
        //   name: 'Overview',
        //   path: 'overview',
        //   click: () => {
        //   },
        //   permissions: [],
        //   badge: false,
        //   isLoad: false,
        // },
        // gVariable.tabs.profile,
        // gVariable.tabs.overview,
        // gVariable.tabs.customers,
        // gVariable.tabs.promotions,
        gVariable.tabs.products,
        // gVariable.tabs.orders,
        // gVariable.tabs.orders_pending,
        // gVariable.tabs.logistic_cal,
        // gVariable.tabs.truck,
        // gVariable.tabs.province,
        gVariable.tabs.issue,
        gVariable.tabs.opc,
        // {
        //   name: 'Report',
        //   path: 'report',
        //   click: () => {
        //   },
        //   permissions: [],
        //   badge: false,
        //   isLoad: false,
        // },
        // gVariable.tabs.carts,

    ]

}
